import React from 'react';
import { Link } from 'wouter';

import { MicromagItem } from '../../types/micromag';
import PageMeta from '../partials/PageMeta';

import styles from '../../styles/pages/text.module.css';

interface TextPageProps {
    title?: string | null;
    content?: string | null;
}

function TextPage({ title = null, content = null }: TextPageProps) {
    return (
        <div className={styles.container}>
            <PageMeta
                title={
                    title !== null
                        ? `${title} | Extraordinaires, les postiers de l'année`
                        : "Extraordinaires, les postiers de l'année"
                }
            />
            <div className={styles.inner}>
                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{ __html: content || 'Contenu' }}
                ></div>
                <div className={styles.footer}>
                    <Link className={styles.link} href="/" transition>
                        Retourner à la page d'accueil
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default TextPage;
